import React from "react";

export const parsedHTML = (value) => {
    // Willy's TinyEditor sets rate's description with plain HTML, which needs to be interpreted here
    return <div dangerouslySetInnerHTML={{__html: value}}/>;
}